const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};
const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    const normalizedItem = { ...item };

    if (Array.isArray(normalizedItem.values)) {
      normalizedItem.values = setArrayValues(normalizedItem);
    } else if (typeof normalizedItem.values === 'object') {
      normalizedItem.values = [normalizedItem.values.id];
    } else if (!normalizedItem.values) {
      normalizedItem.values = [];
    } else {
      normalizedItem.values = [normalizedItem.values];
    }

    if (
      item.filter_group_id !== undefined &&
      item.filter_group_id !== null &&
      item.filter_group_id !== ''
    ) {
      normalizedItem.filter_group_id = Number(item.filter_group_id);
    } else {
      delete normalizedItem.filter_group_id;
    }

    return normalizedItem;
  });
  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
